document.addEventListener("DOMContentLoaded", function () {
  const lookBookFellas = document.querySelectorAll(".lookbook__wrapper");

  if (lookBookFellas.length) {
    lookBookFellas.forEach((lookBookFella) => {
      lookBookFella.addEventListener("click", function (e) {
        // if the clicked one is currently active, just take the class off it
        if (this.classList.contains("active")) {
          this.classList.remove("active");
          return;
        }
        // remove currently active ones
        removeActivePopups();

        this.classList.add("active");
      });
    });

    // stop clicks on this div or the child anchor tag from propagating up
    document
      .querySelectorAll(".lookbook__product-container")
      ?.forEach((productContainer) => {
        productContainer.addEventListener("click", (e) => {
          e.stopPropagation();
        });
      });

    // TODO: removed this for more feedback too
    // document.querySelector(".wlb-image")?.addEventListener("click", () => {
    //   removeActivePopups();
    // });
  }

  // TODO: add handler for click on overall image that will close the popup
});

function removeActivePopups() {
  const activeLookBookFellas = document.querySelectorAll(
    ".lookbook__wrapper.active"
  );
  // check there are active ones
  if (activeLookBookFellas && activeLookBookFellas.length) {
    activeLookBookFellas.forEach(function (activeLookBookFella) {
      // remove active from them
      activeLookBookFella.classList.remove("active");
    });
  }
}
